<template>
    <div>
        <!--搜索表单-->
        <div class="search-box">
            <el-form ref="searchForm"  :inline="true" :rules="searchRules" :model="searchForm" >
                <el-form-item label="材料名称:" prop="name">
                    <el-input size="mini" maxlength="32" show-word-limit  v-model="searchForm.name" placeholder="请输入材料名称"></el-input>
                </el-form-item>
                <el-form-item label="材料编码:" prop="code">
                    <el-input size="mini" maxlength="32" show-word-limit  v-model="searchForm.code" placeholder="请输入材料编码"></el-input>
                </el-form-item>
                <el-form-item label="生效年份:" prop="year">
                    <el-date-picker
                        size="mini"
                        v-model="searchForm.year"
                        type="year"
                        placeholder="选择生效年份"
                        format="yyyy"
                        value-format="yyyy" >
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="适用考生类型" prop="type">
                    <el-select v-model="searchForm.type" size="mini" filterable  placeholder="请选择适用考生类型">
                        <el-option v-for="item in studentTypeList" :key="item.name" :label="item.name" :value="item.name">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button plain size="mini" type="primary" icon="el-icon-search" id="findBtn" v-display:sysUploadFileType-find @click="()=>{this.searchForm.pager.page=1;this.submit();}">查询</el-button>
                    <el-button plain size="mini" type="warning" icon="el-icon-refresh" @click="clear">清空</el-button>
                    <el-button plain size="mini" type="success" icon="el-icon-refresh-left" @click="()=>{this.searchForm.pager.page=1;this.submit();}">刷新</el-button>
                    <el-button plain size="mini" type="primary" v-display:sysUploadFileType-save icon="el-icon-plus" @click="showAddDialog" >新增</el-button>
                    <el-dropdown>
                         <el-button type="primary" size="mini" plain style="margin: 0px 10px 0px 10px">
                             批量操作<i class="el-icon-arrow-down el-icon--right"></i>
                         </el-button>
                         <el-dropdown-menu slot="dropdown">
                             <el-dropdown-item v-display:sysUploadFileType-batchDelete icon="el-icon-delete" @click.native="batchDelete">批量删除</el-dropdown-item>
							 <el-dropdown-item v-display:sysUploadFileType-batchDelete icon="el-icon-tickets" @click.native="batchCopy">批量复制</el-dropdown-item>
							 <el-dropdown-item v-display:sysUploadFileType-batchUpdate icon="el-icon-edit" @click.native="showBatchUpdateDialog">批量修改</el-dropdown-item>
                             <el-dropdown-item v-display:sysUploadFileType-batchReplace icon="el-icon-edit" @click.native="showBatchReplaceDialog">批量替换</el-dropdown-item>
                             <el-dropdown-item v-display:sysUploadFileType-leadingCurrent icon="el-icon-upload" @click.native="leadingInSysUploadFileTypeCurrent">自定义导入</el-dropdown-item>
                             <el-dropdown-item v-display:sysUploadFileType-leadingIn icon="el-icon-upload" @click.native="leadingInSysUploadFileType">导入</el-dropdown-item>
                             <el-dropdown-item v-display:sysUploadFileType-export icon="el-icon-download" @click.native="exportSysUploadFileType">导出</el-dropdown-item>
                             <el-dropdown-item v-display:sysUploadFileType-exportField icon="el-icon-download" @click.native="exportSysUploadFileTypeDialog">导出选择字段</el-dropdown-item>
                             <el-dropdown-item v-display:sysUploadFileType-exportModule icon="el-icon-download" @click.native="exportSysUploadFileTypeModule('upsertForm')">下载模板</el-dropdown-item>
                         </el-dropdown-menu>
                     </el-dropdown>
                </el-form-item>
            </el-form>
         </div>
        <!--表格-->
        <el-table border size="mini" class="table-ui" :stripe="true"  :data="tableData" @selection-change="changeFun"  @sort-change="sortChange" >
            <el-table-column type="selection" width="40px" style="text-align: center;margin: auto"></el-table-column>
            <el-table-column show-overflow-tooltip prop="sequence" label="材料序号"></el-table-column>
            <el-table-column show-overflow-tooltip prop="name" label="材料名称"></el-table-column>
            <el-table-column show-overflow-tooltip prop="code" label="材料编码"></el-table-column>
            <el-table-column show-overflow-tooltip prop="year" label="生效年份"></el-table-column>
            <el-table-column show-overflow-tooltip prop="type" label="适用学生类型">
                <template slot-scope="scope">
                    <div v-if="scope.row.type">
                        <el-tag
                            style="margin-right: 5px"
                            size="mini"
                            v-for="item in scope.row.type.split(',')"
                            :key="item"
                            effect="dark">
                            {{ item }}
                        </el-tag>
                    </div>
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="updateTime" label="修改时间" sortable="custom"></el-table-column>
            <el-table-column show-overflow-tooltip prop="createTime" label="创建时间" sortable="custom"></el-table-column>
            <el-table-column fixed="right" label="操作" width="80"  >
                <template slot-scope="scope">
                    <el-dropdown>
                        <span class="el-dropdown-link" style="color: #409EFF">
                        操作<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item v-display:sysUploadFileType-update @click.native="showUpdateDialog(scope.row.id)">修改</el-dropdown-item>
                            <el-dropdown-item v-display:sysUploadFileType-look @click.native="toLook($event,scope.row.id)">查看</el-dropdown-item>
                            <el-dropdown-item v-display:sysUploadFileType-delete @click.native="deleteData(scope.row.id)">删除</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
            </el-table-column>
            <div slot="empty"><no-data></no-data></div>
        </el-table>
        <el-pagination
                style="margin-top: 10px;padding-bottom: 20px;"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="searchForm.pager.totalCount"
                :page-size="searchForm.pager.pageSize"
                :current-page.sync="searchForm.pager.page"
                :page-sizes="[10, 20, 30, 40, 50, 100]"
                @size-change="sizeChange"
                @current-change="currentChange"
                @prev-click="currentChange"
                @next-click="currentChange"
        ></el-pagination>
        <!--添加或者修改表单-->
        <el-dialog :close-on-click-modal="false" :title="dialog.title"   width="680px" :visible.sync="dialog.dialogFormVisible">
            <el-form class="upsertForm"  :model="upsertForm" :rules="rules" ref="upsertForm" label-width="110px" :inline="true">
                <input type="hidden" :value="upsertForm.id">
              <el-form-item label="材料名称" prop="name">
                   <el-input size="mini" maxlength="255" show-word-limit style="width: 520px" v-model="upsertForm.name" placeholder="请输入材料名称" auto-complete="off"></el-input>
             </el-form-item>
                <el-form-item label="材料序号" prop="sequence">
                    <el-input-number v-model="upsertForm.sequence" size="mini" style="width: 200px"  :min="1" label="请输入序号"></el-input-number>
                </el-form-item>
              <el-form-item label="材料编码" prop="code">
                   <el-input size="mini" maxlength="20" show-word-limit  v-model="upsertForm.code" placeholder="请输入材料编码" auto-complete="off"></el-input>
             </el-form-item>
              <el-form-item label="生效年份" prop="year">
                  <el-date-picker
                      size="mini"
                      v-model="upsertForm.year"
                      type="year"
                      placeholder="选择生效年份"
                      format="yyyy"
                      value-format="yyyy" >
                  </el-date-picker>
             </el-form-item>
                <el-form-item label="适用考生类型" prop="type">
                    <el-select v-model="upsertForm.type" size="mini" filterable multiple collapse-tags placeholder="请选择适用考生类型">
                        <el-option v-for="item in studentTypeList" :key="item.name" :label="item.name" :value="item.name">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button plain size="mini"  @click="dialog.dialogFormVisible = false">取 消</el-button>
                <el-button plain size="mini"  type="primary" v-if="dialog.title=='增加'" v-display:sysUploadFileType-save @click="saveOrUpdate('upsertForm')">确 定</el-button>
                <el-button plain size="mini"  type="primary" v-else v-display:sysUploadFileType-update @click="saveOrUpdate('upsertForm')">确 定</el-button>
            </div>
        </el-dialog>
        <!--查看详情-->
        <el-dialog :close-on-click-modal="false" title="查看"   width="680px" :visible.sync="lookVisible">
            <div>
                <el-form class="upsertForm" :inline="true" label-width="110px">
                    <el-form-item label="材料名称" prop="name">
                        <el-input size="mini" v-model="upsertForm.name" style="width: 520px" readonly auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="材料序号" prop="sequence">
                        <el-input v-model="upsertForm.sequence" size="mini" readonly label="请输入序号"></el-input>
                    </el-form-item>
                    <el-form-item label="材料编码" prop="code">
                        <el-input size="mini" v-model="upsertForm.code" readonly auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="生效年份" prop="year">
                        <el-input size="mini" v-model="upsertForm.year" readonly auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="适用学生类型" prop="type">
                        <el-input size="mini" v-model="upsertForm.type" readonly auto-complete="off"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button plain size="mini" class="large" @click="lookVisible = false">取 消</el-button>
            </div>
        </el-dialog>
        <!--批量修改-->
        <el-dialog :close-on-click-modal="false" :title="batchDialog.title"   width="680px" :visible.sync="batchDialog.dialogFormVisible">
            <el-form class="upsertForm"  :model="upsertForm" ref="upsertForm" label-width="110px" :inline="true">
                <el-form-item label="材料名称" prop="name">
                    <el-input size="mini" maxlength="255" show-word-limit style="width: 520px" v-model="upsertForm.name" placeholder="请输入材料名称" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="材料序号" prop="sequence">
                    <el-input-number v-model="upsertForm.sequence" size="mini" style="width: 200px"  :min="1" label="请输入序号"></el-input-number>
                </el-form-item>
                <el-form-item label="材料编码" prop="code">
                    <el-input size="mini" maxlength="20" show-word-limit  v-model="upsertForm.code" placeholder="请输入材料编码" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="生效年份" prop="year">
                    <el-date-picker
                        size="mini"
                        v-model="upsertForm.year"
                        type="year"
                        placeholder="选择生效年份"
                        format="yyyy"
                        value-format="yyyy" >
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="适用考生类型" prop="type">
                    <el-select v-model="upsertForm.type" size="mini" filterable multiple collapse-tags placeholder="请选择适用考生类型">
                        <el-option v-for="item in studentTypeList" :key="item.name" :label="item.name" :value="item.name">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="mini" @click="batchDialog.dialogFormVisible = false">取 消</el-button>
                <el-button size="mini" type="primary" @click="batchUpdate('upsertForm')">确 定</el-button>
            </div>
        </el-dialog>
        <!--导入结果-->
        <el-dialog :close-on-click-modal="false" :title="dialogExcel.title"   width="650px" :visible.sync="dialogExcel.dialogFormVisible">
            <div v-if="dialogExcel.title=='导入结果'">
                <el-badge :value="cnt" class="item" style="margin: 10px 20px 10px 0px">
                    <el-button size="mini">导入总数</el-button>
                </el-badge>
                <el-badge :value="successCnt" class="item" type="primary" style="margin: 10px 20px 10px 10px">
                    <el-button size="mini">导入成功</el-button>
                </el-badge>
                <el-badge :value="errorNumber" class="item" type="warning" style="margin: 10px 20px 10px 10px">
                    <el-button size="mini">导入失败</el-button>
                </el-badge>
                <el-table border size="mini" v-show="errorNumber>0" :stripe="true" :data="uploadData" style="margin-top: 10px">
                        <el-table-column show-overflow-tooltip prop="name" label="材料名称"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="code" label="材料编码"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="year" label="生效年份"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="updateTime" label="修改时间" sortable="custom"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="createTime" label="创建时间" sortable="custom"></el-table-column>
                </el-table>
        </div>
            <div v-if="dialogExcel.title=='导入'">
                <el-upload class="lead-in-th"
                   style="border:1px #4dbd73 solid;text-align: center;line-height: 50px;border-radius: 5px;margin-top:30px;color: #4dbd73 ;"
                   :action="uploadUrl"
                   :headers="headers"
                   multiple
                   :show-file-list="false"
                   :on-success="handleSysUploadFileTypeSuccess"
                   :before-upload="beforeSysUploadFileTypeUpload">
                    <div class="" style="width: 440px;height: 50px;">导入</div>
                </el-upload>
                <div class="lead-in-th" @click="exportSysUploadFileTypeModule('upsertForm')" style="border:1px #4dbd73 solid;text-align: center;line-height: 50px;border-radius: 5px;margin-top:30px;color: #fff ;background-color: #51c993">下载模板</div>
            </div>
        </el-dialog>
        <!--选择字段导出-->
        <el-dialog :close-on-click-modal="false"  :title="exportDialogExcel.title"  width="650px" :visible.sync="exportDialogExcel.dialogFormVisible">
           <div style="height: 400px;overflow-y: auto;width: 100%" >
               <el-table border size="mini"  :stripe="true" :data="tableFieldData" style="margin-top: 20px" @selection-change="changeTableFieldFun"  >
                   <el-table-column type="selection" fixed="left" width="40"></el-table-column>
                   <el-table-column prop="key" label="英文字段名" ></el-table-column>
                   <el-table-column prop="name" label="中文字段名" ></el-table-column>
                   <el-table-column prop="newName" label="重命名字段" >
                       <template slot-scope="scope">
                           <el-input  placeholder="重命名字段" maxlength="20" size="mini" v-model="tableFieldData[scope.$index].newName"></el-input>
                       </template>
                   </el-table-column>
               </el-table>
           </div>
            <div slot="footer" class="dialog-footer">
                <el-button plain size="mini" @click="exportDialogExcel.dialogFormVisible = false">取 消</el-button>
                <el-button plain size="mini" icon="el-icon-download"  type="success" @click="exportSysUploadFileTypeByField">确认导出</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import axios from 'axios';
    import fileDownload from "js-file-download";
    import noData from '@/components/noData/noData';
    export default {
        name: "sysUploadFileType",
        components: { noData },
        data() {
            return {
                searchForm:{
                   id:'',
                   adminId:'',
                   adminName:'',
                    sequence:'',
                   name:'',
                   code:'',
                   year:'',
                    type:'',
                   updateTime:'',
                   createTime:'',
                   keyWord:'',
                   replaceField:'',
                   replaceValue:'',
                   replaceContent:'',
                   pager:{
                        sortField:'create_time',
                        sortOrder:'desc',
                        page:1,
                        pageSize:10,
                        totalCount:0,
                        keyWordField:'',
                       like:'name,code'
                   }
                },
                tableData: [],
                upsertForm:{
                    id:'',
                    adminId:'',
                    adminName:'',
                    sequence:'',
                    name:'',
                    code:'',
                    year:'',
                    type:'',
                    updateTime:'',
                    createTime:''
                },
                searchRules: {
                    adminId: [
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    adminName: [
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    name: [
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    code: [
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    year: [
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    updateTime: [
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    createTime: [
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    replaceField: [
                        { required: true, message: '请选择替换字段', trigger: 'blur' },
                    ],
                    replaceValue: [
                        { required: true, message: '请输入替换值', trigger: 'blur' },
                    ],
                    replaceContent: [
                        { required: true, message: '请输入替换内容', trigger: 'blur' },
                    ],
                },
                rules: {
                    adminId: [
                        { required: true, message: '请输入用户编号', trigger: 'blur' },
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    adminName: [
                        { required: true, message: '请输入用户名称', trigger: 'blur' },
                        {  max: 20, message: '长度必须少于20个字符', trigger: 'blur' }
                    ],
                    sequence: [
                        { required: true, message: '请输入材料序号', trigger: 'blur' },
                    ],
                    name: [
                        { required: true, message: '请输入材料名称', trigger: 'blur' },
                        {  max: 255, message: '长度必须少于255个字符', trigger: 'blur' }
                    ],
                    code: [
                        { required: true, message: '请输入材料编码', trigger: 'blur' },
                        {  max: 20, message: '长度必须少于20个字符', trigger: 'blur' }
                    ],
                    year: [
                        { required: true, message: '请选择生效年份', trigger: 'blur' },
                    ],
                    type: [
                        { required: true, message: '请选择适用学生类型', trigger: 'blur' },
                    ],
                    updateTime: [
                        { required: true, message: '请输入修改时间', trigger: 'blur' },
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    createTime: [
                        { required: true, message: '请输入创建时间', trigger: 'blur' },
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                },
                dialog:{
                    dialogFormVisible:false,
                    title:'增加'
                },
                lookVisible:false,
                headers: {
                    token: this.$store.getters.getToken
                },
                rowData: [],
                cnt: '',
                successCnt: '',
                errorNumber: '',
                uploadData: [],
                uploadUrl: `${home}/sysUploadFileType/importByExcel`,
                dialogExcel:{
                    dialogFormVisible:false,
                    title:'导入'
                },
                exportDialogExcel:{
                    dialogFormVisible:false,
                    title:'导出选择字段',
                    id:'',
                },
                tableFieldData:[],
                fieldData:[],
                excelParam:{
                    data:'',
                    excelExportList:''
                },
                batchDialog:{
                    dialogFormVisible:false,
                    title:'批量修改'
                },
                studentTypeList:[],
            }
        },
        created(){
            this.$set(this.searchForm,"year", new Date().getFullYear().toString());
            this.getStudentTypeList();
        },
        mounted(){
            let findBtn=document.querySelector('#findBtn');
            findBtn&&this.submit();
            
        },
        methods: {
            changeTableFieldFun(row) {
                this.fieldData = [];
                for (var i = 0; i < row.length; i++) {
                    this.fieldData.push(row[i]);
                }
            },
            changeFun(row) {
                this.rowData = [];
                for (var i = 0; i < row.length; i++) {
                    this.rowData.push(row[i].id);
                }
            },
            sortChange({ column, prop, order }){
                this.searchForm.pager.sortField=prop;
                this.searchForm.pager.sortOrder=order?order.replace(/ending$/,''):'';
                this.submit();
            },
            sizeChange(pageSize){
                this.searchForm.pager.pageSize=pageSize;
                this.submit();
            },
            currentChange(page){
                this.searchForm.pager.page=page;
                this.submit();
            },
            showAddDialog(){
                this.dialog.dialogFormVisible=true;
                this.dialog.title='增加';
                objUtil.setToDefault(this.upsertForm);
                this.$nextTick(()=>{
                    this.$refs.upsertForm.clearValidate();
                });
            },
            showUpdateDialog(id){
                axios({
                    url:`${home}/sysUploadFileType/update/findSysUploadFileTypeById/${id}`,
                    method:'GET'
                }).then(res=>{
                    Object.assign(this.upsertForm,res.data);
                    if(this.upsertForm.type){
                        this.upsertForm.type = this.upsertForm.type.split(",");
                    }
                    this.dialog.dialogFormVisible=true;
                    this.dialog.title = '修改';
                    this.$nextTick(()=>{
                        this.$refs.upsertForm.clearValidate();
                    });
                }).catch(error=>{

                })

            },
            saveOrUpdate(formName){
                this.$refs[formName].validate(valid=>{
                    if(valid){
                        if(this.upsertForm.type){
                            this.upsertForm.type = this.upsertForm.type.join(",");
                        }
                        axios({
                            url:`${home}/sysUploadFileType/${this.dialog.title==='增加'?'saveSysUploadFileType':'update/updateSysUploadFileType'}`,
                            method:'POST',
                            data:this.upsertForm
                        }).then(res=>{
                            this.$message({
                                message: this.dialog.title+'成功',
                                type: 'success'
                            });
                            this.dialog.dialogFormVisible = false;
                            this.submit();
                        }).catch(error=>{
                            //do something
                        })


                    }
                })
            },
            deleteData(id){
                this.$confirm('删除吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios({
                        url: `${home}/sysUploadFileType/deleteSysUploadFileType/${id}`,
                        method: 'GET'
                    }).then(res => {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.submit();
                    }).catch(error => {

                    })
                }).catch(() => {

                });

            },
            submit(){
                axios({
                    url:`${home}/sysUploadFileType/findSysUploadFileTypesByCondition`,
                    method:'POST',
                    data:this.searchForm
                }).then(res=>{
                    if(res.data.length===0&&this.searchForm.pager.page>1&&res.totalCount>0){
                        this.searchForm.pager.page--;
                        this.submit();
                    }else{
                        this.tableData=res.data;
                        this.searchForm.pager.totalCount=res.totalCount;
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            clear(){
                this.$refs['searchForm'].resetFields();
            },
            toLook($event,id){
                this.lookVisible=true;
                axios({
                    url:`${home}/sysUploadFileType/look/lookSysUploadFileTypeById/${id}`,
                    method:'GET'
                }).then(res=>{
                    Object.assign(this.upsertForm,res.data);
                }).catch(error=>{
                    console.log(error);
                })
            },
            leadingInSysUploadFileType() {
                this.dialogExcel.dialogFormVisible = true;
                this.dialogExcel.title = '导入';
            },
            exportSysUploadFileType() {
                axios({
                    url: `${home}/sysUploadFileType/exportSysUploadFileType`,
                    method: "POST",
                    data: this.searchForm,
                    responseType: "arraybuffer"
                }).then(res => {
                    fileDownload(res, "材料上传配置列表导出.xls");
                });
            },
            exportSysUploadFileTypeModule() {
                axios({
                    url: `${home}/sysUploadFileType/exportSysUploadFileTypeModule`,
                    method: "GET",
                    responseType: "arraybuffer"
                }).then(res => {
                    fileDownload(res, "材料上传配置导入模板.xls");
                });

            },
            handleSysUploadFileTypeSuccess(res, file) {
                this.loading.close();
                this.dialogExcel.dialogUploadVisible = false;
                if (res.result.success== true) {
                    if(res.data.successCnt>0){
                        this.cnt = res.data.sumCnt;
                        this.successCnt = res.data.successCnt;
                        this.errorNumber = res.data.errorNumber;
                        this.uploadData = res.data.objectList;
                        this.$message({
                            message: "导入成功",
                            type: "success"
                        });
                        this.submit();
                        this.dialogExcel.dialogFormVisible = true;
                        this.dialogExcel.title = '导入结果';
                    }else{
                        this.cnt = res.data.sumCnt;
                        this.successCnt = res.data.successCnt;
                        this.errorNumber = res.data.errorNumber;
                        this.uploadData = res.data.objectList;
                        this.$message({
                            message: "导入失败",
                            type: "warning"
                        });
                        this.dialogExcel.dialogFormVisible = true;
                        this.dialogExcel.title = '导入结果';
                    }
                } else{
                    this.$message({
                        message: "模板有误或数据为空",
                        type: "error"
                    });
                    this.dialogExcel.dialogUploadErrorVisible = true;
                }
            },
            beforeSysUploadFileTypeUpload(file) {
                this.loading = this.$loading({
                    lock: true,
                    text: "Loading",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.7)"
                });
                const fileName = file.name.toLowerCase();
                if (!(fileName.endsWith(".xls") || fileName.endsWith(".xlsx"))) {
                    this.loading.close();
                    this.$message.error("上传模板只能是 xls、xlsx 格式!");
                    return false;
                }
                return true;
            },
            batchDelete(){
                if (this.rowData.length <= 0) {
                    this.$message({
                        type: "error",
                        message: "请勾选数据!"
                    });
                    return;
                }
                this.$confirm("确认批量删除吗?", "温馨提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    axios({
                        url: `${home}/sysUploadFileType/batchDeleteSysUploadFileType`,
                        method: "post",
                        data: {
                            rowData: this.rowData
                        }
                    }).then(res => {
                        this.$message({
                            type: "success",
                            message: "删除成功!"
                        });
                        this.submit();
                    }).catch(error => {});
                }).catch(() => {
                    this.$message({
                        type: "error",
                        message: "删除失败!"
                    });
                });
            },
            exportSysUploadFileTypeDialog(){
                axios({
                    url: `${home}/sysUploadFileType/getSysUploadFileTypeTableField`,
                    method: "GET",
                }).then(res => {
                    this.tableFieldData = res.data;
                    this.exportDialogExcel.dialogFormVisible = true;
                    this.exportDialogExcel.title = '导出选择字段';
                    this.exportDialogExcel.id = this.id;
                });

            },
            exportSysUploadFileTypeByField() {
                if(this.fieldData.length<=0 ){
                    this.$message({
                        type: "error",
                        message: "请选择需要导出的字段!"
                    });
                }else{
                    this.excelParam.data = this.searchForm;
                    this.excelParam.excelExportList = this.fieldData;
                    axios({
                        url: `${home}/sysUploadFileType/exportSysUploadFileTypeByField`,
                        method: "POST",
                        data: this.excelParam,
                        responseType: "arraybuffer"
                    }).then(res => {
                        fileDownload(res, "材料上传配置选择字段导出.xls");
                    });
                }

            },
            showBatchUpdateDialog(){
                if(this.rowData.length>0){
                    this.batchDialog.dialogFormVisible=true;
                    this.batchDialog.title='批量修改';
                    objUtil.setToDefault(this.upsertForm);
                    this.upsertForm.sequence = undefined;
                    this.$nextTick(()=>{
                        this.$refs.upsertForm.clearValidate();
                    });
                }else{
                    this.$message({
                        type: "error",
                        message: "请勾选数据!"
                    });
                }
            },
            batchUpdate(){
                if (this.rowData.length <= 0) {
                    this.$message({
                        type: "error",
                        message: "请勾选数据!"
                    });
                    return;
                }
                this.$confirm("确认批量修改吗?", "温馨提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    this.upsertForm.rowData = this.rowData;
                    if(this.upsertForm.type){
                        this.upsertForm.type = this.upsertForm.type.join(",");
                    }
                    axios({
                        url: `${home}/sysUploadFileType/batchUpdateSysUploadFileType`,
                        method: "post",
                        data: this.upsertForm
                    }).then(res => {
                        this.$message({
                            type: "success",
                            message: "修改成功!"
                        });
                        this.submit();
                        this.batchDialog.dialogFormVisible=false;
                    }).catch(error => {});
                }).catch(() => {
                    this.$message({
                        type: "error",
                        message: "修改失败!"
                    });
                });
            },
            leadingInSysUploadFileTypeCurrent(){
                objUtil.setToDefault(this.impForm);
                this.impForm.sheetList=[];
                this.impForm.sheetIndexList=[];
                this.impForm.fieldLine = undefined;
                this.impForm.firstDataLine = undefined;
                this.impForm.lastDataLine = undefined;
                this.currentSheet = {};
                this.impForm.processVal = 0;
                this.dialogCurrentExcel.dialogFormVisible = true;
                this.dialogCurrentExcel.title = '自定义导入';
            },
            handleSysDataImpListSelfSuccess(res, file) {
                this.loading.close();
                this.impForm.impPath = res;
            },
            beforeSysDataImpListSelfUpload(file) {
                this.loading = this.$loading({
                    lock: true,
                    text: "Loading",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.7)"
                });
                                            const fileName = file.name.toLowerCase();
                if (!(fileName.endsWith(".xls") || fileName.endsWith(".xlsx"))) {
                    this.loading.close();
                    this.$message.error("上传模板只能是 xls、xlsx 格式!");
                    return false;
                }
                return true;


            },
            impSelfNextDown(){
                if (this.impForm.processVal++ > 1) this.impForm.processVal = 0;
                if(this.impForm.processVal==1){
                  this.findSheetInfoList('impForm');
                }
            },
            impSelfNextUp(){
                if (this.impForm.processVal-- < 0) this.impForm.processVal = 0;
            },
            findSheetInfoList(formName){
                this.$refs[formName].validate(valid=> {
                    if (valid) {
                        this.impForm.archivesCatalogId = this.catalogId;
                        axios({
                            url: `${home}/sysUploadFileType/findSheetInfoByPath`,
                            method: 'POST',
                            data: this.impForm
                        }).then(res => {
                            this.impForm.sheetList = res.data;
                            this.impCatalogDataFieldList = res.data2;
                        }).catch(error => {

                        })
                    }else{
                        this.impForm.processVal = 0;
                    }
                });
            },
            updateImpForm(e){
                this.newSheetList  = [];
                this.newSheetList.push(e);
                this.currentSheet = e;
            },
            setFieldInfo(v,index,s){
                this.impForm.sheetList[this.currentSheet.sheetIndex].dataImportFieldList[index].dataType = s.dataType;
                this.impForm.sheetList[this.currentSheet.sheetIndex].dataImportFieldList[index].maxLength = s.maxLength;
                this.impForm.sheetList[this.currentSheet.sheetIndex].dataImportFieldList[index].tableFieldName = s.key;
            },
            startImpDataByExcel(formName){
                this.$refs[formName].validate(valid=> {
                    if (valid) {
                        this.impForm.sheetList = JSON.parse(JSON.stringify(this.newSheetList));
                        axios({
                            url: `${home}/sysUploadFileType/startImpDataByExcel`,
                            method: 'POST',
                            data: this.impForm
                        }).then(res => {
                            this.$message({
                                message: "操作成功",
                                type: "success"
                            });
                            this.dialogCurrentExcel.dialogFormVisible = false;
                            this.submit();
                        }).catch(error => {

                        })
                    }
                });
            },
            showBatchReplaceDialog(){
                this.searchForm.replaceField='';
                this.searchForm.replaceValue='';
                this.searchForm.replaceContent='';
                axios({
                    url: `${home}/sysUploadFileType/getSysUploadFileTypeTableField`,
                    method: "GET",
                }).then(res => {
                    this.tableFieldData = res.data;
                    this.batchReplaceDialog.dialogFormVisible=true;
                    this.batchReplaceDialog.title='批量替换';
                    objUtil.setToDefault(this.upsertForm);
                    this.$nextTick(()=>{
                        this.$refs.searchForm.clearValidate();
                    });
                });

            },
            batchReplace(formName){
                this.$refs[formName].validate(valid=> {
                    if (valid) {
                        this.$confirm("确认批量替换吗?", "温馨提示", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            type: "warning"
                        }).then(() => {
                            this.searchForm.rowData = this.rowData;
                            axios({
                                url: `${home}/sysUploadFileType/batchReplaceSysUploadFileType`,
                                method: "post",
                                data: this.searchForm
                            }).then(res => {
                                this.$message({
                                    type: "success",
                                    message: "批量替换成功!"
                                });
                                this.submit();
                                this.searchForm.replaceField = '';
                                this.searchForm.replaceValue = '';
                                this.searchForm.replaceContent = '';
                                this.searchForm.rowData = [];
                                this.batchReplaceDialog.dialogFormVisible = false;
                            }).catch(error => {
                            });
                        }).catch(() => {
                            this.$message({
                                type: "error",
                                message: "批量替换失败!"
                            });
                        });
                    }
                });
            },
            getStudentTypeList(){
                axios({
                    url:`${home}/sysDdList/getStudentTypeList`,
                    method:'GET'
                }).then(res=>{
                    this.studentTypeList = res.data;
                }).catch(error=>{
                
                })
            },
			batchCopy(){
				this.$prompt('请输入年份', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					inputPattern: /^(19|20)\d{2}$/,
					inputErrorMessage: '年份格式不正确'
				}).then(({ value }) => {
					axios({
						url: `${home}/sysUploadFileType/batchCopySysUploadFileTypeByYear/${value}`,
						method: "GET",
					}).then(res => {
						this.$message({
							type: "success",
							message: "复制成功!"
						});
						this.submit();
					}).catch(error => {});
				}).catch(() => {
					this.$message({
						type: "error",
						message: "复制失败!"
					});
				});
			},
        }
    }
</script>
